import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormBase from '../../common/FormBase';
import Form from './Form';
import { RADIO_OPTIONS, PREFORM_FIELDS } from './validation/fields';
import { makeInitialState } from '../../../helpers/FormHelper';
import { schema } from './validation/schema';

const PreFormRClubes = ({ ...props }) => {
  const { mobile, motiveId, issueFormName } = props;
  const [state, setState] = useState({});
  const [data, setData] = useState({});
  const [valid, setValid] = useState(false);

  const handleData = (data) => {
    setData(data);
  };

  const onState = (innerState) => {
    setState(innerState);
  };

  const handleValid = (validity) => {
    setValid(validity);
  };

  return (
    <React.Fragment>
      <FormBase
        mobile={mobile}
        title=""
        form={
          <Form
            state={state}
            onData={handleData}
            valid={valid}
            mobile={mobile}
            motiveId={motiveId}
            issueFormName={issueFormName}
          />
        }
        fields={(RADIO_OPTIONS, PREFORM_FIELDS)}
        pre
        data={data}
        formName="PreFormRClubes"
        schema={schema}
        makeInitialState={makeInitialState}
        onState={onState}
        onValid={handleValid}
      />
    </React.Fragment>
  );
};

PreFormRClubes.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  issueFormName: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default PreFormRClubes;
